import React from 'react';
import { Box } from '@mui/material';
import TeamIntegrationsMenu from './TeamIntegrationsMenu';
import TeamIntegrationsSearch from './TeamIntegrationsSearch';
import TeamIntegrationsCategoriesContainer from './TeamIntegrationsCategoriesContainer';
import ConnectionModal from './ConnectionModal';
import TeamNotificationSnackbar from 'team/shared/components/notification/TeamNotificationSnackbar';

const TeamIntegrationsLayout = ({
    searchTerm,
    subteamId,
    availableIntegrations,
    connectedIntegrations,
    loading,
    connectionModalOpen,
    selectedIntegration,
    connecting,
    notification,
    onRefresh,
    onSearchChange,
    onIntegrationClick,
    onDisconnect,
    onConnectConfirm,
    onConnectionModalClose,
    onNotificationClose,
    isIntegrationConnected,
    getConnectionStatus
}) => {
    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ mb: 3 }}>
                <TeamIntegrationsMenu onRefresh={onRefresh} />
                <TeamIntegrationsSearch
                    onSearchChange={onSearchChange}
                    searchTerm={searchTerm}
                />
            </Box>

            <Box sx={{ mb: 3, height: 'calc(100vh - 280px)', minHeight: '600px' }}>
                <TeamIntegrationsCategoriesContainer
                    searchTerm={searchTerm}
                    subteamId={subteamId}
                    availableIntegrations={availableIntegrations}
                    connectedIntegrations={connectedIntegrations}
                    onIntegrationClick={onIntegrationClick}
                    onDisconnect={onDisconnect}
                    isIntegrationConnected={isIntegrationConnected}
                    getConnectionStatus={getConnectionStatus}
                    loading={loading}
                />
            </Box>

            <ConnectionModal
                open={connectionModalOpen}
                onClose={onConnectionModalClose}
                integration={selectedIntegration}
                connectionType={selectedIntegration?.connectionType}
                onConnect={onConnectConfirm}
                loading={connecting}
            />

            <TeamNotificationSnackbar
                open={notification.open}
                message={notification.message}
                severity={notification.severity}
                handleClose={onNotificationClose}
            />
        </Box>
    );
};

export default TeamIntegrationsLayout;

